import React, { Component } from 'react';
import Header from '../header';
import MetaTags from 'react-meta-tags';
import logo from '../common/app2soft/images/logo_color_140X40.png';
import Questions from './views/questions';
import * as DataStatic from '../../api/homeDataStatic';
import Footer from '../footer';
import RaisedButton from 'material-ui/RaisedButton';
import './style.scss';
// https://css-tricks.com/aos-css-driven-scroll-animation-library/
import AOS from 'aos';
import '../../../node_modules/aos/dist/aos.css'; 

import clientsImg from "../common/clients.jpg";
import clientCrEngland from "../common/crEnglandLogo.png";
import client1 from "../common/hanko.png";
import client2 from "../common/ken.png";
import client3 from "../common/rich.png";
import client4 from "../common/casselberry.png";


import packsizeImg from '../common/app2soft/images/packsize-logo-medium.png'

export default class PageController extends Component {
    constructor(props){
        super(props);
        this.handleClick = this.handleClick.bind();
        AOS.init();
    }

    componentWillReceiveProps (){ 
        AOS.refresh(); 
    } 

    componentDidMount(){
        // let pageName = this.props.match.params.name;
    }

    handleClick = () => {
        console.log( this )
        this.props.history.push("/build-your-team");
    }

    render(){
        const styles = {
            backgroundImage: `url(${clientsImg})`,
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
            backgroundPosition:'center',
            height: '550px'
        }
        const styleGrid = {
            width: "61.25rem",
            margin: " 100px auto"
        }
        return(
            <div key={`page-clients`}>
                <MetaTags>
                    <title>{`App2soft | Clients`}</title>
                    <meta name="description" content="" />
                    <meta name="keywords" content="" />
                    <meta name="author" content="Upway Solutions" />
                    <meta property="og:image" content={`${logo}`} />
                </MetaTags>
                <Header animation={false}/>
                <section className="page-clients">
                    <div className="page-title" style={styles}>
                        <div className="title" data-aos="fade-down"> 
                            <h2 data-aos="fade-up">Meet our most outstanding and fastest growing clients</h2>
                        </div>
                    </div>
                    <div className="main" data-aos="fade-down">
                        <div className="testimonials" data-aos="fade-up">
                            <div className="title">
                                <img src={`${packsizeImg}`} /><br/><br/>
                                <p>Founded in 2002, Over 300 employees, $100 to
                                    $500 million in Revenue</p>
                            </div>
                            <div className="list">
                                <div className="item">
                                    <img src={`${client1}`} alt="Image" width="163" height="168"/>
                                    <p>“The Costa Rica office is an essential business partner and we continue 
                                        to look to them for reliable service. We greatly appreciate our association 
                                        with App2Soft.”<br/><b>Hanko Kiessner - CEO</b></p>
                                </div>
                                <div className="item">
                                    <img src={`${client2}`} alt="Image" width="163" height="168"/>
                                    <p>“App2Soft is a world-class resource provider. The talent they have acquired 
                                        for our software and QA teams is exceptional”<br/>
                                        <b>Ken Fultz - Global Software Manager</b></p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="main" data-aos="fade-down">
                        <div className="testimonials" data-aos="fade-up">
                            <div className="title">
                                <img src={`${clientCrEngland}`} />
                                <p>Founded in 1920, 5,001-10,000 employees, 
                                    Over $1.1 Billion in Revenue</p>
                            </div>
                            <div className="list" data-aos="fade-down">
                                <div className="item">
                                    <img src={`${client3}`} alt="Image" width="163" height="168"/>
                                    <p>“Our developers in Costa Rica have quickly become highly-valued members 
                                        of our technology and business teams. They are a vital part of our 
                                        team and critical to our development strategy. 
                                        App2Soft has made it easy to build up and manage 
                                        this high-powered team.”<br/><b>Rich Farr - VP of Technology</b></p>
                                </div>
                                <div className="item" data-aos="fade-down">
                                    <img src={`${client4}`} alt="Image" width="163" height="168"/>
                                    <p>“Having managed development teams all over the world, I’ve finally 
                                        found a team location that really works with our need for real-time 
                                        collaboration during U.S. work hours and without the communication challenges, 
                                        misinterpretation of requirements, and the many struggles 
                                        with project timelines.”<br/>
                                        <b>Casselberry – Software Development Director</b></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <div className="questions" data-aos="fade-up">
                    <h2>Build your online team</h2>
                    <RaisedButton label="Get Started" primary={true} onClick={ this.handleClick }/>
                </div>
                <Footer />
            </div>
        )
    }
}




// WEBPACK FOOTER //
// ./src/components/clients_page/index.js